import React from 'react';

const SubscriptionPlan = ({ plan, userSubscription, isSubmitting, onPlanChange }) => {
    const grossPrice = typeof plan.priceGross === 'number' ? plan.priceGross : (plan.price * (1 + (plan.vat || 0)));
    const discountedPrice = typeof plan.discountedPriceGross === 'number' ? plan.discountedPriceGross : grossPrice;
    
    const isCurrentPlan = userSubscription?.planName === plan.name;
    let buttonText = 'Subscribe';
    let isDisabled = isSubmitting || isCurrentPlan;

    if (userSubscription) {
        buttonText = isCurrentPlan ? '目前方案' : '更換方案';
    } else {
        buttonText = plan.price === 0 ? '免費開始' : '選擇方案';
    }

    return (
        <div className={`plan-card ${isCurrentPlan ? 'subscribed' : ''}`}>
            <h3>{plan.name}</h3>
            <p className="price">
                {plan.price > 0 && discountedPrice < grossPrice ? (
                    <>
                        <span className="original-price" style={{ textDecoration: 'line-through', opacity: 0.7, marginRight: 8 }}>
                            ${grossPrice.toFixed(2)}
                        </span>
                        <span className="discounted-price" style={{ fontWeight: 600 }}>
                            ${discountedPrice.toFixed(2)}
                        </span>
                        <span style={{ marginLeft: 6, fontSize: 12, color: '#d00' }}>{Math.round((1 - discountedPrice / grossPrice) * 100)}% off</span>
                        {` / ${plan.billingCycle}`}
                    </>
                ) : (
                    <>
                        ${grossPrice.toFixed(2)} / {plan.billingCycle}
                    </>
                )}
            </p>
            <ul className="features">
                <li>Total Threads: {plan.metadata.thread_count_total_limit || 'Unlimited'}</li>
                <li>Messages Limit: {plan.metadata.message_weighted_length_total_limit || 'Unlimited'}</li>
                {plan.isTrial && <li className="trial-feature">Trial Available!</li>}
            </ul>
            <button 
                onClick={() => onPlanChange(plan)}
                disabled={isDisabled}
                className="subscribe-button"
            >
                {buttonText}
            </button>
        </div>
    );
};

export default SubscriptionPlan;